import { render, staticRenderFns } from "@/clickbuy/purchase/views/filling-in-form/filling-in-form.pug?vue&type=template&id=b28514c4&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/clickbuy/purchase/views/filling-in-form/filling-in-form.scss?vue&type=style&index=0&id=b28514c4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28514c4",
  null
  
)

export default component.exports